module.exports = __webpack_public_path__ + "static/yotta-splash-screen-1a09138f7bdcb82ad296e78a1ef7b625.mp4";